import React, { useEffect, useRef, useState } from 'react';

import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';

import { Container, DrawerContent, ToggleControl, Title, Total } from './styles';
import useTranslate from '@src/i18n/useTranslate';
import { useAppSelector } from '@src/core/hooks';
import useCurrencyFormat from '@src/hooks/useCurrencyFormat';
import { getDirectLinkTotalCurrencyInfo, hasDirectLinkItems } from '@src/domains/direct-links';
import { directLinkStateSelector } from '@src/stores/directLink';
import { currentOrderSelector } from '@src/features/orders';
import Summary from '../Summary';

interface DrawerProps {
  open: boolean;
  onToggle: () => void;
}

export const SummaryDrawer = (props: DrawerProps) => {
  const { open, onToggle } = props;

  const { i18n } = useTranslate();
  const { formatCurrencyInfo } = useCurrencyFormat();

  const [contentHeight, setContentHeight] = useState(0);

  const { directLink } = useAppSelector(directLinkStateSelector);
  const currentOrder = useAppSelector(currentOrderSelector);

  const contentRef = useRef<HTMLDivElement>(null);

  const showSummary = hasDirectLinkItems(directLink);
  const total = formatCurrencyInfo(getDirectLinkTotalCurrencyInfo(directLink!, currentOrder));

  useEffect(() => {
    setContentHeight(contentRef.current?.scrollHeight || 0);
  }, [directLink, currentOrder]);

  return (
    <Container>
      {showSummary ? (
        <>
          <ToggleControl onClick={onToggle}>
            {open ? <MdKeyboardArrowDown size={24} /> : <MdKeyboardArrowUp size={24} />}
          </ToggleControl>

          <Title>{i18n('checkout_purchase_summary')}</Title>

          <DrawerContent $open={open} $contentHeight={contentHeight} ref={contentRef}>
            <Summary directLink={directLink!} showTotal={false} />
          </DrawerContent>
        </>
      ) : null}

      <Total>
        <p>{i18n('direct_link_summary_total')}</p> <p>{total}</p>
      </Total>
    </Container>
  );
};

export default SummaryDrawer;
